import React from 'react';

interface FormSectionProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  children,
  className = '',
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {(title || description) && (
        <div className="mb-4">
          {title && (
            <h3 className="text-lg font-semibold text-[var(--color-default-font)] mb-1">
              {title}
            </h3>
          )}
          {description && (
            <p className="text-sm text-[var(--color-subtext-color)]">
              {description}
            </p>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default FormSection;

